import "../styles/confirm-close-modal.scss";
import { Modal } from "./modal";

export function ConfirmCloseModal({
  onDelete,
  onSaveDraft,
  onCancel,
  showConfirmDelete,
}) {
  return (
    <Modal className="confirm-close-modal">
      {showConfirmDelete && (
        <>
          <h4>Are you sure you want to do this?</h4>
          <div
            className="detail-delete"
            onClick={(e) => {
              e.preventDefault();
              onDelete();
            }}
          >
            Delete Message
          </div>
        </>
      )}
      {!showConfirmDelete && (
        <>
          <h4>
            Are you sure you want to discard your Message?
            <br />
            All unsaved changes will be lost?
          </h4>
          <div
            id="discard"
            className="delete"
            onClick={(e) => {
              e.preventDefault();
              onDelete();
            }}
          >
            Discard Message
          </div>
          <div
            id="save-draft"
            className="save-draft"
            onClick={(e) => {
              e.preventDefault();
              onSaveDraft();
            }}
          >
            Save Draft
          </div>
        </>
      )}
      <div
        className="cancel"
        onClick={(e) => {
          e.preventDefault();
          onCancel();
        }}
      >
        Cancel
      </div>
    </Modal>
  );
}
